import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../api/config';
import { Link, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import '../styles/style.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { toast, ToastContainer } from 'react-toastify';
import ImageWithLoader2 from '../components/ImageWithLoader2';
import ReactModal from 'react-modal';

function Sidebar({ show, toggle }) {
 
  const [showAccountMenu, setShowAccountMenu] = useState(false);

    
    const navigate = useNavigate();


   // Fetch User Details
   const { data: user, isLoadingP, isErrorP } = useQuery({
    queryKey: ['userDetails'],
    queryFn: () =>
      axios.get(`${API_URL}/user-details-api`, { withCredentials: true })
        .then(res => res.data),
    staleTime: 0,
    cacheTime: Infinity,
  });



  const handleLogout = async () => {
    try {
      const res = await axios.post(`${API_URL}/logout`, {}, { withCredentials: true });

      if (res.data.Status === "Success") {
        // Clear any stored tokens/session data
        localStorage.removeItem("token");
        sessionStorage.clear();

        toast.success("Logged out successfully");
        navigate("/login"); // redirect to login page
      } else {
        toast.error(res.data.message || "Logout failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error during logout");
    }
  };


  const [websiteModalOpen, setWebsiteModalOpen] = useState(false);
  const [loadingWebsite, setLoadingWebsite] = useState(true);


  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [loadingTerms, setLoadingTerms] = useState(true);
         
        const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
        const [loadingPrivacy, setLoadingPrivacy] = useState(true);


  if (!show) return null; // Hide completely when closed
  return (
    <div
      className="position-fixed top-0 start-0 h-100"
      style={{ width: '100vw', zIndex: 9999 }}
      onClick={toggle}
    >

       <ToastContainer />
      <div
        className="h-100 shadow d-flex flex-column position-relative"
        style={{
          width: '220px',
          maxWidth: '100%',
          backgroundColor: '#e6f4ea',
          borderRight: '1px solid #ccc'
        }}
        onClick={(e) => e.stopPropagation()}
      >
  
  <div className="text-center py-4 border-bottom bg-white">
  {isLoadingP ? (
    <p>Loading user...</p>
  ) : isErrorP ? (
    <p>Error loading user</p>
  ) : (
    <div className="d-flex flex-column align-items-center">
      <ImageWithLoader2
        className="rounded-circle shadow"
        src={user?.image_file_final}
        placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
        fadeDuration={800}
        blurAmount={15}
        alt="Profile"
        style={{
          width: '72px',
          height: '72px',
          objectFit: 'cover',
          border: '3px solid #75B437',
          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
        }}
      />
      <div className="mt-2 fw-bold">
        {user?.n_prefix} {user?.name} {user?.last_name}
      </div>
    </div>
  )}
</div>


   
        <div className="px-3 pt-3">
          <div
            className="d-flex justify-content-between align-items-center nav-link text-dark"
            style={{ cursor: 'pointer' }}
            onClick={() => setShowAccountMenu(!showAccountMenu)}
          >
            <span><i className="bi bi-person text-success me-2"></i> Account</span>
            <i className={`bi ${showAccountMenu ? 'bi-chevron-up' : 'bi-chevron-right'} text-muted`}></i>
          </div>
          {showAccountMenu && (
            <ul className="nav flex-column mt-2 ms-3">
              <li className="nav-item mb-1">

              <button  className="nav-link text-dark small"
                         onClick={() => navigate('/profile', { state: {memberId: user?.id } })}
                        >
                        <i className="bi bi-person me-2"></i> Profile</button>
              </li>
              <li className="nav-item mb-1">
                <Link to="/profile-settings" className="nav-link text-dark small">
                  <i className="bi bi-gear me-2"></i> Settings
                </Link>
              </li>
              {/*<li className="nav-item mb-1">
                <Link to="/family-requests" className="nav-link text-dark small">
                  <i className="bi bi-list-ul me-2"></i> Requests
                </Link>
              </li>*/}
            </ul>
          )}
        </div>

        <hr className="mx-3" />

        <div className="p-3 flex-grow-1 overflow-auto pt-0">
          <ul className="nav flex-column">
            <li className="nav-item mb-2">
              <Link to="/search-people" className="nav-link text-dark">
                <i className="bi bi-search me-2"></i> Search People
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/search-family" className="nav-link text-dark">
                <i className="bi bi-search-heart me-2"></i> Search Family
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/family-members" className="nav-link text-dark">
                <i className="bi bi-people-fill me-2"></i> Members
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/family-members-deceased" className="nav-link text-dark ">
                <i className="bi bi-flower1 me-2"></i> In Loving Memory
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/family-posts" className="nav-link text-dark">
                <i className="bi bi-journal-text me-2"></i> Posts
              </Link>
            </li>
            
            <li className="nav-item mb-3">
              <Link to="/chat-list" className="nav-link text-dark">
                <i className="bi bi-chat-dots me-2"></i> Chat
              </Link>
            </li>


            <li className="nav-item mb-3">
              <Link to="/family-events" className="nav-link text-dark">
                <i className="bi bi-calendar me-2"></i> Family Events
              </Link>
            </li>

            <li className="nav-item mb-3">
              <Link to="/timeline" className="nav-link text-dark">
                <i className="bi bi-clock-history me-2"></i> Timeline
              </Link>
            </li>
            

          </ul>

          <hr />

     
          <ul className="nav flex-column">
            <li className="nav-item mb-2">
              <Link to="/need-help" className="nav-link text-dark">
                <i className="bi bi-question-circle me-2 text-success"></i> Need Help?
              </Link>
            </li>
            <li className="nav-item mb-2">
            <Link to="https://oret.africa/" className="nav-link text-dark" target='_blank'>
                <i className="bi bi-globe me-2 text-success"></i> Our Website
              </Link>
            </li>
            <li className="nav-item mb-2">
              <button onClick={() => setPrivacyModalOpen(true)} className="nav-link text-dark">
                <i className="bi bi-shield-lock me-2 text-success"></i> Privacy
              </button>
            </li>
            <li className="nav-item mb-2">
              <Link onClick={() => setTermsModalOpen(true)} className="nav-link text-dark">
                <i className="bi bi-file-earmark-text me-2 text-success"></i> Terms
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/report-concern" className="nav-link text-dark">
                <i className="fas fa-exclamation-circle me-2 text-success"></i> Report a Concern
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link text-dark">
                <i className="bi bi-share me-2 text-success"></i> Share
              </Link>
            </li>
            <li className="nav-item">
              <Link to="#" className="nav-link text-dark">
                <i className="bi bi-star me-2 text-success"></i> Rate Us
              </Link>
            </li>
          </ul>
        </div>



               {/* modals here*/}


               <ReactModal
                    isOpen={websiteModalOpen}
                    onRequestClose={() => setWebsiteModalOpen(false)}
                    className="Modal modal-lg"
                    overlayClassName="Overlay" style={{
                      overlay: { zIndex: 10000, backgroundColor: "rgba(0,0,0,0.5)" },
                      content: { zIndex: 10001 }
                    }}
                  >
                    <div className="modal-header">
                      <h5 className="modal-title">Oret Africa</h5>
                      <button
                        type="button"
                        className="btn-close modalCloseButton"
                        onClick={() => setWebsiteModalOpen(false)}
                      ></button>
                    </div>
              
                    <div
                      className="modal-body p-0 position-relative"
                      style={{ maxHeight: "60vh", overflow: "hidden" }}
                    >
                      {loadingTerms && (
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            right: "0",
                            bottom: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "rgba(255,255,255,0.8)",
                            zIndex: 10,
                          }}
                        >
                          <div className="spinner-border text-primaryx" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
              
                      <iframe
                        src="https://oret.africa/"
                        title="Terms of Use"
                        style={{ width: "100%", height: "80vh", border: "none" }}
                        onLoad={() => setLoadingWebsite(false)}
                      ></iframe>
                    </div>
              
                    <div className="modal-footer"></div>
                  </ReactModal>
              

              
                                      
                    <ReactModal
                    isOpen={termsModalOpen}
                    onRequestClose={() => setTermsModalOpen(false)}
                    className="Modal modal-lg"
                    overlayClassName="Overlay" style={{
                      overlay: { zIndex: 10000, backgroundColor: "rgba(0,0,0,0.5)" },
                      content: { zIndex: 10001 }
                    }}
                  >
                    <div className="modal-header">
                      <h5 className="modal-title">Terms of Use</h5>
                      <button
                        type="button"
                        className="btn-close modalCloseButton"
                        onClick={() => setTermsModalOpen(false)}
                      ></button>
                    </div>
              
                    <div
                      className="modal-body p-0 position-relative"
                      style={{ maxHeight: "60vh", overflow: "hidden" }}
                    >
                      {loadingTerms && (
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            right: "0",
                            bottom: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "rgba(255,255,255,0.8)",
                            zIndex: 10,
                          }}
                        >
                          <div className="spinner-border text-primaryx" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
              
                      <iframe
                        src="https://oret.africa/terms-and-conditions/"
                        title="Terms of Use"
                        style={{ width: "100%", height: "80vh", border: "none" }}
                        onLoad={() => setLoadingTerms(false)}
                      ></iframe>
                    </div>
              
                    <div className="modal-footer"></div>
                  </ReactModal>
              
              
              
              
              
                  <ReactModal
                    isOpen={privacyModalOpen}
                    onRequestClose={() => setPrivacyModalOpen(false)}
                    className="Modal modal-lg"
                    overlayClassName="Overlay"  style={{
                      overlay: { zIndex: 10000, backgroundColor: "rgba(0,0,0,0.5)" },
                      content: { zIndex: 10001 }
                    }}
                  >
                    <div className="modal-header">
                      <h5 className="modal-title">Privacy Policy</h5>
                      <button
                        type="button"
                        className="btn-close modalCloseButton"
                        onClick={() => setPrivacyModalOpen(false)}
                      ></button>
                    </div>
              
                    <div
                      className="modal-body p-0 position-relative"
                      style={{ maxHeight: "60vh", overflow: "hidden" }}
                    >
                      {loadingPrivacy && (
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            right: "0",
                            bottom: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "rgba(255,255,255,0.8)",
                            zIndex: 10,
                          }}
                        >
                          <div className="spinner-border text-primaryx" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
              
                      <iframe
                        src="https://oret.africa/privacy-policy/"
                        title="Privacy Policy"
                        style={{ width: "100%", height: "80vh", border: "none" }}
                        onLoad={() => setLoadingPrivacy(false)}
                      ></iframe>
                    </div>
              
                    <div className="modal-footer"></div>
                  </ReactModal>


        <div className="p-3 border-top small text-muted sidebar-footer">
          <ul className="nav flex-column mb-2">
            <li className="nav-item">
              {/*<Link to="/login" className="nav-link text-dark">
                <i className="bi bi-box-arrow-right me-2 text-danger"></i> Logout
              </Link>*/}

              <button
                onClick={handleLogout}
                className="nav-link text-dark"
                style={{ border: "none", background: "none", cursor: "pointer" }}
              >
                <i className="bi bi-box-arrow-right me-2 text-danger"></i> Logout
              </button>

            </li>
          </ul>
          <div>
            Logged in as <strong>{user?.n_prefix} {user?.name} {user?.last_name}</strong>
          </div>
        </div>


        <div
          style={{
            fontSize: '0.75rem',
            textAlign: 'center',
            color: '#6c757d',
            paddingBottom: '10px'
          }}
        >
          v1.0.0
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
